import React,{Component} from 'react';
import {reduxForm} from 'redux-form';
import * as actions from '../../actions';
import { Link, browserHistory} from 'react-router';

const baseAssets = 'https://aquadeals.in/admin/assets/';

 class MobileNumber extends Component{
	 constructor(props){
    super(props);
    this.state={
      status: '',
      msg: '',
    };
    this.handleFormSubmit=this.handleFormSubmit.bind(this);
  }
  renderAlert(){
    if(this.props.errorMessage){
      return (
        <div className="error">
          <strong></strong>
            {this.props.errorMessage}
        </div>
      )
    }
  }
  componentWillReceiveProps(newProps) {
     if (newProps.formdata.status === 'success' && newProps.formdata.page === "otp") {
        localStorage.setItem('pwd',newProps.formdata.pwd);
        localStorage.setItem('mobile_number',newProps.formdata.mobile);
        // browserHistory.push('/verify');
        // window.location.reload();
      }
  }
  componentDidMount(){
    if(localStorage.token && localStorage.user_id){
      browserHistory.push('/');
    }
  }
  handleFormSubmit(formProps){
    localStorage.setItem('mobile_number',this.refs.mobile_num.value);
    this.props.mobileNumber(formProps);
    this.setState({
      status: this.props.formdata.status
    });
   
  }

	render(){
		const {handleSubmit,fields:{mobile}} = this.props;
        document.title ="AquaDeals Registration - You find,buy best deals by register with us";
        document.getElementsByTagName("META")[2].content="You find,buy best deals by register with us";
		return(
			<div className="mob_deals mob_login_page mob_social_loginpage">
    <section className="tot_pag">
        <div className="page_hdr">
            <div className="container">
                <h5><Link onClick={()=>{browserHistory.goBack()}}><i><img src={baseAssets+'images/web_imgs/back_arrow.png'} width="18px" alt=""/></i></Link>Sign In or Register</h5>
                <a href="/" className="home_newicon"><img src={baseAssets+'images/web_imgs/home1.png'} alt="Home"/></a>
            </div>
        </div>
  <section className="pag_cntnt signup_cntnt">
  <div className="col-md-6 col-md-offset-3">
    <div className="">
    <div className="enquire_form signup_blk proced_blk" style={{marginLeft:'20px',marginRight:'20px'}}>
      <div className="clr">&nbsp;</div>
      <div className="newlogin_logo"><img src={baseAssets+'icons/web_icons/cc_footer_icon.png'} alt=" "/></div>
      <form className="mtrl_elmnts" onSubmit={handleSubmit(this.handleFormSubmit.bind(this))}>
      <div className="col-md-12">
        <div className="col-md-12 col-xs-12 col-sm-12">
        <div className="group">      
          <img src={baseAssets+'icons/web_icons/cell_dl.png'} alt="" style={{position:'absolute',top:'11px',left:'0px'}} />
          <input {...mobile} type="text" placeholder="Enter Mobile" required maxLength={10} ref="mobile_num"/>
          <span className="highlight"></span>
          <span className="bar"></span>
          <span style={{color:'red',fontSize:'12px'}}>{mobile.touched && mobile.error ? mobile.error : ''}</span>
        </div>
        <div className="clr">&nbsp;</div>
        <div><button action="submit" className="btn mob_social_btn">PROCEED <i className="glyphicon glyphicon-menu-right"></i></button></div>
        </div>
      </div>
  </form>
  <div className="clr"></div>
    </div>
    </div>
    
    </div>

{/*    <!-- login form end --> */}
  </section>
 
</section>   
</div>
		);
	}
}

function validate(formProps){
const errors = {};

 const mobile_Pattern = /^([0-9]){10}$/;
  if (formProps.mobile && !mobile_Pattern.test(formProps.mobile)) {
    errors.mobile = 'Enter valid mobile number';
  }


return errors;
}

function mapStateToProps(state){
  return {
    errorMessage:state.auth.error,
    authenticated:state.auth.authenticated,
    formdata:state.auth.formdata
  };
}

export default reduxForm({
  form :'register',
  fields:['mobile'],
  validate:validate

},mapStateToProps,actions)(MobileNumber);



/** WEBPACK FOOTER **
 ** ./src/components/Auth/mob_num.js
 **/